module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};


//////////////////
// WEBPACK FOOTER
// ./~/entities/maps/xml.json
// module id = 197
// module chunks = 0